const theme = {
  color1: "#EEEBDD",
  color2: "#D8B6A4",
  color3: "#F6D7A7",
  color4: "#96C7C1",
  color5: "#007774",
  yellow500: "#998b4d",
  yellowGradient:
    "linear-gradient(to right, rgb(186, 173, 117), rgb(153, 139, 77))",
};

module.exports = theme;
